import type { SystemStyleObject } from '@chakra-ui/react';

export const topbarCss: SystemStyleObject = {
  '&': {
    position: 'sticky',
    top: 0,
    zIndex: 'sticky',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: { base: 4, md: 12 },
    height: '60px',
    minHeight: '60px',
    paddingY: 3,
    paddingX: { base: 4, md: 8 },
    bg: 'bg.panel',
    borderBottomWidth: '1px',
    borderColor: 'border',
  },

  '& .tenant': {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    flex: 1,
    minWidth: 0,
  },

  '& .menu-button': {
    display: { base: 'inline-flex', lg: 'none' },
  },

  '& .tenant-name': {
    fontSize: 'md',
    lineHeight: '1.5rem',
    fontWeight: 'semibold',
    color: 'fg',
    truncate: true,
  },

  '& .search': {
    display: { base: 'none', md: 'flex' },
    width: '480px',
    maxWidth: '40vw',
  },

  '& .search .chakra-input': {
    height: 9,
    borderRadius: 'lg',
    fontSize: 'sm',
    bg: 'bg.panel',
  },

  '& .actions': {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },

  '& .bell': {
    color: 'fg',
    _icon: { boxSize: 6 },
  },
};

export const userMenuTriggerCss: SystemStyleObject = {
  '&': {
    borderRadius: 'full',
    focusVisibleRing: 'outside',
    cursor: 'pointer',
  },

  '& .chakra-avatar__root': {
    boxSize: 9,
    bg: 'gray.subtle',
    color: 'gray.fg',
  },

  '& .chakra-avatar__fallback': {
    fontSize: 'sm',
    fontWeight: 'semibold',
  },
};
